import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 951">
    <path d="M500 788.6L191 951l59-344L0 363.3l345.5-50.2L500.1 0l-.1 788.6z" />
    <path d="M500.1 0l154.5 313.1 345.5 50.2L750 607l59 344-309-162.4L191 951l59-344L0 363.3l345.5-50.2L500.1 0z" />
  </svg>
);
